import React from "react";
import preview from "../../../assets/portfolio/crabman/preview.png";

export default function Crabman() {
	return (
		<div
			style={{ margin: "0 2rem", marginTop: "1rem", width: "calc(50% - 4rem)" }}
			data-aos="fade-up">
			<h2
				style={{
					fontWeight: 400,
					fontSize: "16px",
					lineHeight: "16px",
					margin: "1rem 0",
				}}>
				Crabman Scuba{" "}
			</h2>
			<h3>Logo and Branding Design</h3>
			<p>
				Logo and branding design for a local scuba diving company. 
			</p>
			<div
				style={{
					width: "100%",
					height: "400px",
					overflow: "hidden",
					borderRadius: "10px",
					paddingLeft: "2rem",
					paddingTop: "2rem",
					backgroundColor: "#CF373C",
				}}>
				<img
					src={preview}
					alt="Crabman Scuba Logo and Branding Design"
					style={{ height: "110%" }}
				/>
			</div>
		</div>
	);
}
